import PropTypes from "prop-types";
import React, { useContext, useRef } from "react";

import { useUserInfo } from "@swa-ui/authentication";
import { useIntersectionObserver } from "@swa-ui/browser";
import { isResponseOk, useFetch } from "@swa-ui/fetch";
import { usePersistedState } from "@swa-ui/persistence";

import { ChaseContext } from "../ChaseProvider";

const FIRM_OFFER_CONFIRMATION_ENDPOINT = "/api/chase/v2/chase/firm-offer-confirmation";

export const ChaseFirmOfferConfirmation = (props) => {
  const { placementData, children } = props;
  const chasePrequalPlacementRef = useRef(null);
  const { getCustomerInfo } = useUserInfo();
  const { accountNumber } = getCustomerInfo() ?? {};

  const [viewedOffers, setViewedOffers] = usePersistedState({
    defaultValue: {},
    key: "viewed-chase-offer-ids",
  });

  const { chaseDetails: { offerIdentifier } = {} } = useContext(ChaseContext) ?? {};
  const { put, response } = useFetch();

  const { isChasePrequal, viewPort = 50 } = placementData ?? {};
  const observerOptions = {
    freezeOnceVisible: true,
    threshold: parseFloat(viewPort) / 100,
  };

  useIntersectionObserver(chasePrequalPlacementRef, handleChasePlacementViewed, observerOptions);

  return (
    <span className="chaseFirmOfferConfirmation" ref={chasePrequalPlacementRef}>
      {children}
    </span>
  );

  function isPlacementViewed() {
    return !!offerIdentifier && viewedOffers[accountNumber]?.includes(offerIdentifier);
  }

  async function handleChasePlacementViewed() {
    if (!!offerIdentifier && isChasePrequal && !isPlacementViewed()) {
      await put(FIRM_OFFER_CONFIRMATION_ENDPOINT, {
        offerIdentifier,
      });

      if (isResponseOk(response)) {
        updateViewedOffers();
      }
    }
  }

  function updateViewedOffers() {
    if (accountNumber) {
      const userViewedOffers = viewedOffers[accountNumber] ?? [];

      userViewedOffers.push(offerIdentifier);
      setViewedOffers({ ...viewedOffers, [accountNumber]: userViewedOffers });
    }
  }
};

ChaseFirmOfferConfirmation.propTypes = {
  /** children. */
  children: PropTypes.node,

  /** Placement data. */
  placementData: PropTypes.shape({
    isChasePrequal: PropTypes.bool,
    viewPort: PropTypes.string,
  }),
};
